"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderFieldsDict = exports.HeaderFieldsEnum = void 0;
var HeaderFieldsEnum;
(function (HeaderFieldsEnum) {
    HeaderFieldsEnum["COMPANY_NAME"] = "companyName";
    HeaderFieldsEnum["COMPANY_ID"] = "companyId";
    HeaderFieldsEnum["EXPENSE_NUMBER"] = "expenseNumber";
    HeaderFieldsEnum["KIND"] = "kind";
    HeaderFieldsEnum["DATE_PURCHASED"] = "datePurchased";
    HeaderFieldsEnum["NAME"] = "name";
    HeaderFieldsEnum["DESCRIPTION"] = "description";
    HeaderFieldsEnum["TOTAL_GROSS_PRICE"] = "totalGrossPrice";
    HeaderFieldsEnum["TOTAL_NET_PRICE"] = "totalNetPrice";
    HeaderFieldsEnum["TOTAL_TAX"] = "totalTax";
    HeaderFieldsEnum["TAX_RATE"] = "taxRate";
    HeaderFieldsEnum["TAX_BU_CODE"] = "taxBuCode";
    HeaderFieldsEnum["CURRENCY"] = "currency";
    HeaderFieldsEnum["DISCOUNT_DAYS"] = "discountDays";
    HeaderFieldsEnum["DISCOUNT_RATE"] = "discountRate";
    HeaderFieldsEnum["DISCOUNT_AMOUNT"] = "discountAmount";
    HeaderFieldsEnum["DISCOUNT_GROSS_TOTAL"] = "discountGrossTotal";
    HeaderFieldsEnum["COST_CENTER"] = "costCenter";
    HeaderFieldsEnum["COST_CENTER_ID"] = "costCenterId";
    HeaderFieldsEnum["COST_CENTER2_NAME"] = "costCenter2Name";
    HeaderFieldsEnum["COST_CENTER2_CODE"] = "costCenter2Code";
    HeaderFieldsEnum["REQUESTED_BY"] = "requestedBy";
    HeaderFieldsEnum["APPROVED_BY"] = "approvedBy";
    HeaderFieldsEnum["INVOICE_FILES"] = "invoiceFiles";
    HeaderFieldsEnum["DELIVERY_NOTE_FILES"] = "deliveryNoteFiles";
    HeaderFieldsEnum["INVOICE_NUMBER"] = "invoiceNumber";
    HeaderFieldsEnum["INVOICE_DATE"] = "invoiceDate";
    HeaderFieldsEnum["INVOICE_DUE_DATE"] = "invoiceDueDate";
    HeaderFieldsEnum["DATE_PAID_AT"] = "datePaidAt";
    HeaderFieldsEnum["EXPENSE_ACCOUNT_NAME"] = "expenseAccountName";
    HeaderFieldsEnum["EXPENSE_ACCOUNT_CODE"] = "expenseAccountCode";
    HeaderFieldsEnum["STATUS"] = "status";
    HeaderFieldsEnum["VENDOR"] = "vendor";
    HeaderFieldsEnum["VENDOR_CREDITOR_NUMBER"] = "vendorCreditorNumber";
    HeaderFieldsEnum["VENDOR_ADDRESS"] = "vendorAddress";
    HeaderFieldsEnum["VENDOR_DESCRIPTION"] = "vendorDescription";
    HeaderFieldsEnum["VENDOR_VAT"] = "vendorVat";
    HeaderFieldsEnum["VENDOR_TAX_ID"] = "vendorTaxId";
    HeaderFieldsEnum["VENDOR_IBAN"] = "vendorIban";
    HeaderFieldsEnum["VENDOR_BIC"] = "vendorBic";
    HeaderFieldsEnum["VENDOR_CONTACT_PERSON"] = "vendorContactPerson";
    HeaderFieldsEnum["MILEAGE_ADDRESSES"] = "mileageAddresses";
    HeaderFieldsEnum["MILEAGE_DISTANCE"] = "mileageDistance";
    HeaderFieldsEnum["MILEAGE_VEHICLE"] = "vehicle";
    HeaderFieldsEnum["MILEAGE_RATE"] = "customMileageRate";
    HeaderFieldsEnum["HOSPITALITY_ATTENDEES"] = "attendees";
    HeaderFieldsEnum["HOSPITALITY_MERCHANT"] = "merchant";
    HeaderFieldsEnum["PER_DIEM_DESTINATIONS"] = "destinations";
    HeaderFieldsEnum["PER_DIEM_START_DATE"] = "startDate";
    HeaderFieldsEnum["PER_DIEM_START_TIME"] = "startTime";
    HeaderFieldsEnum["PER_DIEM_END_DATE"] = "endDate";
    HeaderFieldsEnum["PER_DIEM_END_TIME"] = "endTime";
    HeaderFieldsEnum["PERFORMANCE_PERIOD_START"] = "performancePeriodStart";
    HeaderFieldsEnum["PERFORMANCE_PERIOD_END"] = "performancePeriodEnd";
    HeaderFieldsEnum["TRIP_FOLDER_NUMBER"] = "tripFolderNumber";
    HeaderFieldsEnum["TRIP_FOLDER_NAME"] = "tripFolderName";
    HeaderFieldsEnum["CPU_DATE"] = "cpuDate";
    HeaderFieldsEnum["CPU_TIME"] = "cpuTime";
    HeaderFieldsEnum["POSTING_PERIOD"] = "postingPeriod";
    HeaderFieldsEnum["TAGS"] = "tags";
    HeaderFieldsEnum["FOLDER_TAGS"] = "folderTags";
})(HeaderFieldsEnum || (exports.HeaderFieldsEnum = HeaderFieldsEnum = {}));
exports.HeaderFieldsDict = {
    [HeaderFieldsEnum.COMPANY_NAME]: "CompanyName",
    [HeaderFieldsEnum.COMPANY_ID]: "CompanyID",
    [HeaderFieldsEnum.TRIP_FOLDER_NUMBER]: "TripFolderNumber",
    [HeaderFieldsEnum.TRIP_FOLDER_NAME]: "TripFolderName",
    [HeaderFieldsEnum.EXPENSE_NUMBER]: "ExpenseNumber",
    [HeaderFieldsEnum.KIND]: "ExpenseType",
    [HeaderFieldsEnum.DATE_PURCHASED]: "PerformanceDate",
    [HeaderFieldsEnum.NAME]: "Items",
    [HeaderFieldsEnum.DESCRIPTION]: "Description",
    [HeaderFieldsEnum.TOTAL_GROSS_PRICE]: "GrossAmount",
    [HeaderFieldsEnum.TOTAL_NET_PRICE]: "NetAmount",
    [HeaderFieldsEnum.TOTAL_TAX]: "TotalTaxAmount",
    [HeaderFieldsEnum.TAX_RATE]: "TaxRate",
    [HeaderFieldsEnum.TAX_BU_CODE]: "BUCode",
    [HeaderFieldsEnum.CURRENCY]: "Currency",
    [HeaderFieldsEnum.DISCOUNT_DAYS]: "DiscountDays",
    [HeaderFieldsEnum.DISCOUNT_RATE]: "DiscountRate",
    [HeaderFieldsEnum.DISCOUNT_AMOUNT]: "DiscountAmount",
    [HeaderFieldsEnum.DISCOUNT_GROSS_TOTAL]: "TotalGrossDiscount",
    [HeaderFieldsEnum.COST_CENTER]: "CostCenter1",
    [HeaderFieldsEnum.COST_CENTER_ID]: "CostCenter1ID",
    [HeaderFieldsEnum.COST_CENTER2_NAME]: "CostCenter2",
    [HeaderFieldsEnum.COST_CENTER2_CODE]: "CostCenter2Code",
    [HeaderFieldsEnum.REQUESTED_BY]: "RequestedBy",
    [HeaderFieldsEnum.APPROVED_BY]: "ApprovalNeededBy",
    [HeaderFieldsEnum.INVOICE_FILES]: "InvoiceFiles",
    [HeaderFieldsEnum.DELIVERY_NOTE_FILES]: "DeliveryNoteFile",
    [HeaderFieldsEnum.INVOICE_NUMBER]: "InvoiceNumber",
    [HeaderFieldsEnum.INVOICE_DATE]: "InvoiceDate",
    [HeaderFieldsEnum.INVOICE_DUE_DATE]: "InvoiceDueDate",
    [HeaderFieldsEnum.DATE_PAID_AT]: "PaidAtDate",
    [HeaderFieldsEnum.EXPENSE_ACCOUNT_NAME]: "ExpenseAccountName",
    [HeaderFieldsEnum.EXPENSE_ACCOUNT_CODE]: "ExpenseAccountCode",
    [HeaderFieldsEnum.STATUS]: "Status",
    [HeaderFieldsEnum.VENDOR]: "Vendor",
    [HeaderFieldsEnum.VENDOR_CREDITOR_NUMBER]: "VendorCreditorNr",
    [HeaderFieldsEnum.VENDOR_ADDRESS]: "VendorAddress",
    [HeaderFieldsEnum.VENDOR_DESCRIPTION]: "VendorDescription",
    [HeaderFieldsEnum.VENDOR_VAT]: "VendorVAT",
    [HeaderFieldsEnum.VENDOR_TAX_ID]: "VendorTaxID",
    [HeaderFieldsEnum.VENDOR_IBAN]: "VendorIBAN",
    [HeaderFieldsEnum.VENDOR_BIC]: "VendorBIC",
    [HeaderFieldsEnum.VENDOR_CONTACT_PERSON]: "VendorContact",
    [HeaderFieldsEnum.MILEAGE_ADDRESSES]: "MilDestAddresses",
    [HeaderFieldsEnum.MILEAGE_DISTANCE]: "Distance",
    [HeaderFieldsEnum.MILEAGE_VEHICLE]: "Vehicle",
    [HeaderFieldsEnum.MILEAGE_RATE]: "CustomMileageRate",
    [HeaderFieldsEnum.HOSPITALITY_ATTENDEES]: "HosAttendees",
    [HeaderFieldsEnum.HOSPITALITY_MERCHANT]: "HosMerchant",
    [HeaderFieldsEnum.PER_DIEM_DESTINATIONS]: "PerdiemDest",
    [HeaderFieldsEnum.PER_DIEM_START_DATE]: "PerDiemStartDate",
    [HeaderFieldsEnum.PER_DIEM_START_TIME]: "PerDiemStartTime",
    [HeaderFieldsEnum.PERFORMANCE_PERIOD_END]: "PerfPeriodEnd",
    [HeaderFieldsEnum.PERFORMANCE_PERIOD_START]: "PerfPeriodStart",
    [HeaderFieldsEnum.PER_DIEM_END_DATE]: "PerDiemReturnDate",
    [HeaderFieldsEnum.PER_DIEM_END_TIME]: "PerDiemReturnTime",
    [HeaderFieldsEnum.CPU_DATE]: "CPUDate",
    [HeaderFieldsEnum.CPU_TIME]: "CPUTime",
    [HeaderFieldsEnum.POSTING_PERIOD]: "PostingPeriod",
    [HeaderFieldsEnum.TAGS]: "Tags",
    [HeaderFieldsEnum.FOLDER_TAGS]: "FolderTags",
};
